import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const ProblemSolutionSection = () => {
  const { t } = useLanguage();

  return (
    <section className="calli-section bg-white relative overflow-hidden" data-testid="problem-solution-section">
      <div className="calli-container relative z-10">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-16">
          {/* Problem */}
          <div className="calli-card rounded-3xl p-8 space-y-6 group hover:border-red-200 transition-all duration-500">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider bg-red-50 text-red-500 border border-red-100">
              ❌ {t("problem_badge")}
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
              {t("problem_title")}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {t("problem_text")}
            </p>
            <div className="relative rounded-2xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=600&auto=format&fit=crop" 
                alt="Child with tablet"
                className="w-full h-48 object-cover grayscale opacity-60 group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-red-900/30 to-transparent"></div>
            </div>
          </div>

          {/* Solution */}
          <div className="calli-card rounded-3xl p-8 space-y-6 group hover:border-green-200 transition-all duration-500">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider bg-green-50 text-green-600 border border-green-100">
              ✓ {t("solution_badge")}
            </span>
            <h2 className="text-2xl md:text-3xl font-bold gradient-text">
              {t("solution_title")}
            </h2>
            <p className="text-gray-600 leading-relaxed">
              {t("solution_text")}
            </p>
            <div className="relative rounded-2xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1586498024141-1940debde48d?w=600&auto=format&fit=crop" 
                alt="Grandfather with grandchild - tender moment"
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-green-900/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
